module.exports = __webpack_public_path__ + "img/blog-divya_gurunath.3bcbcf8f.png";